// Studyo Today Backend
// Package studyo.today.users.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/users/v1/resources/platform.proto (package studyo.today.users.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/users/v1/resources/platform.proto.
 */
export const file_studyo_today_users_v1_resources_platform = /*@__PURE__*/
  fileDesc("Ci5zdHVkeW8vdG9kYXkvdXNlcnMvdjEvcmVzb3VyY2VzL3BsYXRmb3JtLnByb3RvEh9zdHVkeW8udG9kYXkudXNlcnMudjEucmVzb3VyY2VzKl4KCFBsYXRmb3JtEhgKFFBMQVRGT1JNX1VOU1BFQ0lGSUVEEAASEAoMUExBVEZPUk1fV0VCEAESEAoMUExBVEZPUk1fSU9TEAISFAoQUExBVEZPUk1fQU5EUk9JRBADQieqAiRTdHVkeW8uVG9kYXkuVXNlcnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the enum studyo.today.users.v1.resources.Platform.
 */
export const PlatformSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_users_v1_resources_platform, 0);

/**
 * Represents one of the frontend Today platforms.
 *
 * @generated from enum studyo.today.users.v1.resources.Platform
 */
export const Platform = /*@__PURE__*/
  tsEnum(PlatformSchema);

